import React,{useState} from 'react';
import { Link } from "react-router-dom";
import ReactGA from 'react-ga';
import { FaLayerGroup, FaMapMarkerAlt } from 'react-icons/fa';


export default function Card(props){
    const [data] = useState(props.data.data);
    const btnAnalitycs = (nombre) => {
      ReactGA.event({
        category: 'button-home-pruebas',
        action: 'Click button:Ver Detalles:'+nombre
      });
    }

    const status = {
      activo: {
        bar: 'bg-primary',
        badge: 'bg-primary bg-opacity-10 text-primary',
        label: 'Convocatoria vigente',
      },
      proximo: {
        bar: 'bg-yellow-400',
        badge: 'bg-yellow-100 text-yellow-700',
        label: 'Próximamente',
      },
      pasado: {
        bar: 'bg-gray-300',
        badge: 'bg-gray-100 text-gray-500',
        label: 'Convocatoria pasada',
      },
    }[data && data.estado] || {
      bar: 'bg-primary',
      badge: 'bg-gray-100 text-gray-600',
      label: '',
    };

    return (
      <>
        {
          data ?
          <div className="p-3 w-full md:w-1/2 lg:w-1/3">
          <div className="bg-white rounded-2xl h-full border border-gray-200 shadow-sm hover:shadow-lg hover:border-primary transition duration-300 overflow-hidden flex flex-col">
            <div className={`h-1.5 w-full ${status.bar}`}></div>
            <div className="text-fondo px-6 py-5 flex flex-col justify-between flex-1" style={{minHeight: '16rem'}}>
              <div>
                {status.label && (
                  <span className={`inline-block text-xs font-semibold uppercase tracking-wide rounded-full px-3 py-1 mb-3 ${status.badge}`}>
                    {status.label}
                  </span>
                )}
                <div className="font-bold text-lg uppercase text-fondo leading-snug">{data.nombre}</div>
                <p className="font-normal text-sm mt-3 text-gray-600 leading-relaxed">{data.descripcion}</p>
              </div>
              <div className='flex flex-row flex-wrap mt-5 text-sm text-gray-600'>
                <div className="flex items-center mr-4 mb-2">
                  <FaLayerGroup className="text-primary mr-2"/>
                  <span>{data.materias ? data.materias.length : 0} áreas</span>
                </div>
                {data.area && (
                <div className="flex items-center mb-2">
                  <FaMapMarkerAlt className="text-primary mr-2"/>
                  <span>{data.area}</span>
                </div>
                )}
              </div>
              <div className="flex justify-start mt-2 pb-1">
                {
                  data.estado === 'activo' && 
                    <Link 
                    onClick={()=>btnAnalitycs(data.nombre)}
                    className="text-white font-semibold py-2 px-5 rounded-full hover:bg-fondo border-2 border-primary bg-primary" 
                    to={{
                      pathname: `/Details`,
                      search: `?idExam=${props.id}`,
                      data: {data: data,id:props.id},
                    }}
                    >
                      Ver detalles
                    </Link>
                }
                {
                  data.estado === 'proximo' && 
                    <p className="text-fondo font-medium py-2 px-4 rounded-full border border-gray-200 bg-gray-50">
                      {data.fecha}</p>
                }
                {
                  data.estado === 'pasado' && 
                    <p className="text-primary font-semibold py-2 px-5 rounded-full border-2 border-primary hover:bg-primary hover:text-white cursor-pointer">
                      Contáctanos
                    </p>
                }
              </div>
            </div>
          </div>
          </div>
          :null
        }
      </>
      
        
    );
}
